import Api from "../helpers/api";

export const ping = async () => {
  try {
    const response = await Api.get(`/api/v1/authenticate`);
    return response.status === "ok" ? true : false;
  } catch (error) {
    return false;
  }
};

export const login = async (login, password) => {
  let response = {
    success: false,
    message: "",
    errors: [],
  };
  await Api.post(`/api/v1/auth/login`, {
    login: login,
    password: password,
  })
    .then((res) => {
      response.success = true;
      response.message = "Úspešne prihlásený.";
      response.user = res.user;
    })
    .catch((error) => {
      if (error.response.data) {
        for (const key in error.response.data.errors) {
          error.response.data.errors[key].forEach((err) =>
            response.errors.push(err)
          );
        }
      }
    });
  return response;
};

export const logout = async () => {
  let response = {
    success: false,
    message: "",
    errors: [],
  };
  await Api.post(`/api/v1/auth/logout`)
    .then((res) => {
      response.success = true;
      response.message = "Úspešne odhlásený.";
    })
    .catch((error) => {
      if (error.response.data) {
        for (const key in error.response.data.errors) {
          error.response.data.errors[key].forEach((err) =>
            response.errors.push(err)
          );
        }
      }
    });
  return response;
};

export const editaciaUzivatela = async (data) => {
  let response = { success: false, errors: [], successes: [] };
  if (data === undefined) {
    response.errors.push("Chybné dáta.");

    return response;
  }

  await Api.put(`/api/v1/auth/user/password`, {
    password: data.nove_heslo,
    password_confirmation: data.nove_heslo_kontrola,
    current_password: data.stare_heslo,
  })
    .then((res) => {
      response.successes.push("Heslo bolo úspešne zmenené.");
    })
    .catch((error) => {
      if (error.response.data) {
        for (const key in error.response.data.errors) {
          error.response.data.errors[key].forEach((err) =>
            response.errors.push(err)
          );
        }
      }
    });

  return response;
};
